var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_23978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.834 20.3333V23.6667H20.334V29.5H23.6673V23.6667H26.1673L27.0007 20.3333H23.6673V18.6667C23.6673 18.4457 23.7551 18.2337 23.9114 18.0774C24.0677 17.9211 24.2796 17.8333 24.5007 17.8333H27.0007V14.5H24.5007C23.3956 14.5 22.3358 14.939 21.5544 15.7204C20.773 16.5018 20.334 17.5616 20.334 18.6667V20.3333H17.834Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_23978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fcc34e9b941faa0baa71b3098ea72dda.svg";
export { ForwardRef as ReactComponent };